document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initFaq();
  initGaleria();
  initVariantes();
  initCantidad();
  initFormularioProducto();
  initCartBump();
  initExitIntent();
  initStickyAtc();
  initHeroSloomi();
});

// ---------- Hero estilo Sloomi (capas + parallax) ----------

function initHeroSloomi() {
  var hero = document.querySelector('[data-oc-hero-sloomi]');
  if (!hero) return;
  if (!hero.querySelector('.oc-hero__layers')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  hero.classList.add('oc-hero--layers-active');

  var product = hero.querySelector('.oc-hero__layer--product');
  if (!product) return;

  var targetX = 0, targetY = 0, curX = 0, curY = 0, raf = null;

  function isDesktop() {
    return window.innerWidth >= 990;
  }

  function onMouseMove(e) {
    var r = hero.getBoundingClientRect();
    var nx = ((e.clientX - r.left) / r.width) * 2 - 1;
    var ny = ((e.clientY - r.top) / r.height) * 2 - 1;
    targetX = -nx * 10;
    targetY = -ny * 10;
  }

  function onMouseLeave() {
    targetX = 0;
    targetY = 0;
  }

  function tick() {
    curX += (targetX - curX) * 0.08;
    curY += (targetY - curY) * 0.08;
    product.style.setProperty('--px', curX.toFixed(2) + 'px');
    product.style.setProperty('--py', curY.toFixed(2) + 'px');
    raf = requestAnimationFrame(tick);
  }

  if (isDesktop()) {
    hero.addEventListener('mousemove', onMouseMove);
    hero.addEventListener('mouseleave', onMouseLeave);
    tick();
  }

  window.addEventListener('resize', function () {
    if (isDesktop()) return;
    targetX = 0;
    targetY = 0;
    curX = 0;
    curY = 0;
    product.style.setProperty('--px', '0px');
    product.style.setProperty('--py', '0px');
  });
}

// ---------- Carrito (cajón lateral, sin página /cart) ----------

function ocApplyCartSections(sections) {
  if (!sections) return;
  try {
    if (sections['cart-drawer']) {
      var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var newInner = parsed.querySelector('.drawer__inner');
      var currentInner = document.querySelector('cart-drawer .drawer__inner');
      if (newInner && currentInner) currentInner.innerHTML = newInner.innerHTML;
    }
    if (sections['cart-icon-bubble']) {
      var parsedBubble = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var bubbleSection = parsedBubble.querySelector('.shopify-section');
      var currentBubble = document.getElementById('cart-icon-bubble');
      if (bubbleSection && currentBubble) currentBubble.innerHTML = bubbleSection.innerHTML;
    }
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl) drawerEl.classList.remove('is-empty');
  } catch (e) {}
}

function ocOpenCartDrawer() {
  var drawerEl = document.querySelector('cart-drawer');
  if (drawerEl && typeof drawerEl.open === 'function') drawerEl.open();
}

function initCartBump() {
  var busy = false;
  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-oc-bump-checkbox]');
    if (!cb || busy) return;
    busy = true;
    var variantId = cb.dataset.variantId;
    var checked = cb.checked;
    cb.disabled = true;

    var url = checked ? '/cart/add.js' : '/cart/change.js';
    var body = checked
      ? { items: [{ id: parseInt(variantId, 10), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }
      : { id: variantId, quantity: 0, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname };

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || 'error'); });
        return res.json();
      })
      .then(function (data) {
        ocApplyCartSections(data.sections);
      })
      .catch(function () {
        cb.checked = !checked;
        cb.disabled = false;
        alert('No se pudo actualizar el carrito. Inténtalo de nuevo.');
      })
      .finally(function () { busy = false; });
  });
}

function initReveals() {
  var els = document.querySelectorAll('.oc-reveal');
  // Sin IntersectionObserver, el CSS ya las deja visibles por defecto: nada que hacer.
  if (!els.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('oc-visible');
          io.unobserve(entry.target);
        }
      });
    },
    // rootMargin generoso: se revela mucho antes de entrar en pantalla, para que
    // en una conexión lenta no se vea "la página no ha cargado" al ir bajando.
    { threshold: 0.05, rootMargin: '400px 0px -5% 0px' }
  );
  // Solo se arma (y por tanto solo se puede ver apagada) si de verdad hay JS
  // corriendo para revelarla; si algo falla a partir de aquí, ya era visible.
  els.forEach(function (el) { el.classList.add('oc-reveal-armed'); io.observe(el); });
}

// ---------- Barra de compra fija (solo móvil, solo ficha del Kit) ----------
function initStickyAtc() {
  var bar = document.querySelector('[data-oc-sticky-atc]');
  var mainBtn = document.querySelector('[data-oc-producto] [data-oc-add]');
  if (!bar || !mainBtn || !('IntersectionObserver' in window)) return;

  var cta = bar.querySelector('[data-oc-sticky-atc-cta]');
  // Sin lógica propia: dispara el submit del formulario principal (mismo fetch, mismo cajón).
  if (cta) cta.addEventListener('click', function () { mainBtn.click(); });

  var hideTimer = null;
  var io = new IntersectionObserver(function (entries) {
    var mainVisible = entries[0].isIntersecting;
    clearTimeout(hideTimer);
    if (mainVisible) {
      bar.classList.remove('oc-sticky-atc--visible');
      bar.setAttribute('aria-hidden', 'true');
      hideTimer = setTimeout(function () { bar.hidden = true; }, 200);
    } else {
      bar.hidden = false;
      bar.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () { bar.classList.add('oc-sticky-atc--visible'); });
    }
  });
  io.observe(mainBtn);
}

function initFaq() {
  var items = document.querySelectorAll('.oc-faq__item');
  if (!items.length) return;
  items.forEach(function (item) {
    var q = item.querySelector('.oc-faq__q');
    var a = item.querySelector('.oc-faq__a');
    if (!q || !a) return;
    q.addEventListener('click', function () {
      var isOpen = item.classList.contains('oc-open');
      items.forEach(function (other) {
        other.classList.remove('oc-open');
        var otherA = other.querySelector('.oc-faq__a');
        if (otherA) otherA.style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('oc-open');
        a.style.maxHeight = a.scrollHeight + 'px';
      }
    });
  });
}

function initGaleria() {
  document.querySelectorAll('[data-oc-galeria]').forEach(function (galeria) {
    var strip = galeria.querySelector('[data-oc-galeria-strip]');
    var slides = galeria.querySelectorAll('[data-oc-galeria-slide]');
    var thumbs = galeria.querySelectorAll('[data-oc-galeria-thumb]');
    var dots = galeria.querySelectorAll('[data-oc-galeria-dots] .oc-pdp__dot');
    if (!strip || !slides.length) return;

    function activar(indice) {
      slides.forEach(function (s, i) { s.classList.toggle('oc-active', i === indice); });
      thumbs.forEach(function (t, i) { t.classList.toggle('oc-active', i === indice); });
      dots.forEach(function (d, i) { d.classList.toggle('oc-active', i === indice); });
    }

    // Escritorio: clic en miniatura = cambiar cuál slide es la .oc-active (sin tocar src).
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var indice = parseInt(thumb.getAttribute('data-indice'), 10);
        if (isNaN(indice)) return;
        activar(indice);
        if (slides[indice]) slides[indice].scrollIntoView({ block: 'nearest', inline: 'start' });
      });
    });

    // Móvil: el scroll-snap nativo mueve la tira; solo hace falta sincronizar los puntos.
    if (dots.length) {
      var ticking = false;
      strip.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            var indice = Math.round(strip.scrollLeft / (strip.clientWidth || 1));
            activar(indice);
            ticking = false;
          });
        },
        { passive: true }
      );
    }
  });
}

function initVariantes() {
  document.querySelectorAll('[data-oc-producto]').forEach(function (root) {
    var dataEl = root.querySelector('[data-oc-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var idInput = root.querySelector('[data-oc-variant-id]');
    var precioEl = root.querySelector('[data-oc-precio]');
    var compareEl = root.querySelector('[data-oc-compare]');
    var addBtn = root.querySelector('[data-oc-add]');
    var opciones = root.querySelectorAll('[data-oc-opcion]');

    function estadoSeleccionado() {
      var seleccion = [];
      opciones.forEach(function (opt) {
        var activo = opt.querySelector('.oc-selected');
        seleccion.push(activo ? activo.getAttribute('data-valor') : null);
      });
      return seleccion;
    }

    function encontrarVariante(seleccion) {
      return variantes.find(function (v) {
        return v.options.every(function (val, i) { return val === seleccion[i]; });
      });
    }

    function money(cents) {
      return (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function actualizar() {
      var seleccion = estadoSeleccionado();
      var variante = encontrarVariante(seleccion);
      if (!variante) return;
      if (idInput) idInput.value = variante.id;
      if (precioEl) precioEl.textContent = money(variante.price);
      if (compareEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          compareEl.textContent = money(variante.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !variante.available;
        addBtn.textContent = variante.available ? addBtn.getAttribute('data-texto-disponible') : addBtn.getAttribute('data-texto-agotado');
      }
      opciones.forEach(function (opt, i) {
        opt.querySelectorAll('[data-valor]').forEach(function (pill) {
          var valor = pill.getAttribute('data-valor');
          var prueba = seleccion.slice();
          prueba[i] = valor;
          var existe = variantes.some(function (v) {
            return v.options.every(function (val, j) { return val === prueba[j]; });
          });
          pill.disabled = !existe;
        });
      });
    }

    opciones.forEach(function (opt) {
      opt.querySelectorAll('[data-valor]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.disabled) return;
          opt.querySelectorAll('[data-valor]').forEach(function (p) { p.classList.remove('oc-selected'); });
          pill.classList.add('oc-selected');
          actualizar();
        });
      });
    });

    actualizar();
  });
}

function initFormularioProducto() {
  document.querySelectorAll('[data-oc-producto]').forEach(function (root) {
    var form = root.querySelector('form');
    if (!form) return;
    var upsell = root.querySelector('[data-oc-upsell-toggle]');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var addBtn = form.querySelector('[data-oc-add]');
      var idInput = form.querySelector('[data-oc-variant-id]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (!idInput || !idInput.value) return;

      var items = [{ id: parseInt(idInput.value, 10), quantity: parseInt((qtyInput && qtyInput.value) || '1', 10) }];
      if (upsell && upsell.checked) {
        var upsellId = upsell.getAttribute('data-variant-id');
        if (upsellId) items.push({ id: parseInt(upsellId, 10), quantity: 1 });
      }

      var textoOriginal = addBtn ? addBtn.textContent : '';
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Añadiendo…';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || 'error'); });
          return res.json();
        })
        .then(function (data) {
          ocApplyCartSections(data.sections);
          ocOpenCartDrawer();
        })
        .catch(function () {
          alert('No se pudo añadir al carrito. Inténtalo de nuevo.');
        })
        .finally(function () {
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.textContent = textoOriginal;
          }
        });
    });
  });
}

function initCantidad() {
  document.querySelectorAll('[data-oc-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var minus = wrap.querySelector('[data-oc-qty-minus]');
    var plus = wrap.querySelector('[data-oc-qty-plus]');
    if (!input) return;
    minus && minus.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    plus && plus.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });
}

// ---------- Pop-up de salida (downsell, una vez por sesión) ----------
//
// Disparadores:
// - Escritorio: el ratón sale del viewport por arriba (mouseout con clientY<=0),
//   igual que antes.
// - Móvil (pointer: coarse, sin ratón): scroll rápido hacia arriba. Es el
//   equivalente táctil más parecido al gesto de escritorio — llevar el pulgar
//   hacia arriba de golpe suele preceder a tocar la barra de direcciones o el
//   botón "atrás" del navegador, igual que mover el ratón hacia la pestaña.
//   Se descartó la inactividad prolongada: en una ficha con bastante texto
//   (los bloques "Qué incluye"/"Lo que no hace"/FAQ) penalizaría a quien
//   simplemente se para a leer, que es justo a quien no hay que interrumpir.
//   Se descartó también interceptar el botón "atrás" (manipular el historial):
//   es una práctica hostil que puede penalizar SEO/Ads, y el usuario lo pidió
//   explícitamente evitar.
//
// Condiciones para poder saltar (cualquier disparador):
// - Han pasado al menos 20s en la página, O se ha hecho scroll de al menos 40%.
// - El carrito está vacío en ese momento (comprobado en vivo con /cart.js).
// - Máximo una vez por sesión (sessionStorage, ya existía).
// - Nunca en /cart (la plantilla ni siquiera pinta el snippet, ver theme.liquid).
function initExitIntent() {
  var popup = document.getElementById('oc-exit-popup');
  if (!popup) return;

  var STORAGE_KEY = 'oc_exit_shown';
  var MIN_SECONDS = 20;
  var MIN_SCROLL_PERCENT = 40;
  var FAST_SCROLL_UP_PX = 80; // subida mínima...
  var FAST_SCROLL_UP_MS = 220; // ...en esta ventana de tiempo, para contar como "gesto rápido"

  var lastActive = null;
  var startTs = Date.now();
  var maxScrollPercent = 0;
  var opening = false; // evita dos comprobaciones de carrito solapadas

  function currentScrollPercent() {
    var doc = document.documentElement;
    var scrollable = doc.scrollHeight - doc.clientHeight;
    if (scrollable <= 0) return 100;
    return Math.min(100, Math.max(0, (window.scrollY / scrollable) * 100));
  }

  function alreadyShown() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return true;
    }
  }

  function markShown() {
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}
  }

  function isEligibleByTimeOrScroll() {
    return Date.now() - startTs >= MIN_SECONDS * 1000 || maxScrollPercent >= MIN_SCROLL_PERCENT;
  }

  function cartIsEmpty() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) { return cart.item_count === 0; })
      .catch(function () { return false; }); // ante la duda, no interrumpir
  }

  function maybeOpen() {
    if (alreadyShown() || opening || !isEligibleByTimeOrScroll()) return;
    opening = true;
    cartIsEmpty()
      .then(function (empty) {
        if (empty) openPopup();
      })
      .finally(function () { opening = false; });
  }

  function openPopup() {
    if (alreadyShown()) return;
    markShown();
    lastActive = document.activeElement;
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { popup.classList.add('oc-exit--visible'); });
    var closeBtn = popup.querySelector('.oc-exit__close');
    if (closeBtn) closeBtn.focus();
    document.addEventListener('keyup', onKeyup);
  }

  function closePopup() {
    popup.classList.remove('oc-exit--visible');
    popup.setAttribute('aria-hidden', 'true');
    setTimeout(function () { popup.hidden = true; }, 250);
    document.removeEventListener('keyup', onKeyup);
    if (lastActive && typeof lastActive.focus === 'function') lastActive.focus();
  }

  function onKeyup(e) {
    if (e.code === 'Escape') closePopup();
  }

  // Scroll: alimenta el % máximo (gate de 40%) y, en táctil, detecta el gesto rápido hacia arriba.
  var isCoarsePointer = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  var lastScrollY = window.scrollY;
  var lastScrollTs = Date.now();
  var scrollTicking = false;

  document.addEventListener(
    'scroll',
    function () {
      if (alreadyShown() || scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        var now = Date.now();
        maxScrollPercent = Math.max(maxScrollPercent, currentScrollPercent());

        if (isCoarsePointer) {
          var deltaY = lastScrollY - y; // positivo = ha subido
          var deltaT = now - lastScrollTs;
          if (deltaY >= FAST_SCROLL_UP_PX && deltaT <= FAST_SCROLL_UP_MS) {
            maybeOpen();
          }
        }

        lastScrollY = y;
        lastScrollTs = now;
        scrollTicking = false;
      });
    },
    { passive: true }
  );

  // Escritorio: el ratón sale del viewport por arriba.
  document.addEventListener('mouseout', function (e) {
    if (alreadyShown()) return;
    if (e.clientY > 0) return;
    if (e.relatedTarget || e.toElement) return;
    maybeOpen();
  });

  popup.querySelectorAll('[data-oc-exit-close]').forEach(function (el) {
    el.addEventListener('click', closePopup);
  });

  var addBtn = popup.querySelector('[data-oc-exit-add]');
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var variantId = parseInt(addBtn.dataset.variantId, 10);
      var discountCode = addBtn.dataset.discountCode;
      var textoOriginal = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Añadiendo…';

      // Dos pasos: 1) añadir el Kit, 2) aplicar el código en segundo plano
      // (POST /cart/update.js admite "discount" sin que el cliente lo escriba).
      // Solo se pide el repintado de secciones en el segundo paso, para no
      // mostrar el precio sin descuento un instante antes del descontado.
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || 'error'); });
          var updateBody = { updates: {}, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname };
          if (discountCode) updateBody.discount = discountCode;
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(updateBody)
          }).then(function (res2) {
            if (!res2.ok) return res2.json().then(function (data) { throw new Error(data.description || 'error'); });
            return res2.json();
          });
        })
        .then(function (data) {
          ocApplyCartSections(data.sections);
          closePopup();
          ocOpenCartDrawer();
        })
        .catch(function () {
          alert('No se pudo añadir al carrito. Inténtalo de nuevo.');
        })
        .finally(function () {
          addBtn.disabled = false;
          addBtn.textContent = textoOriginal;
        });
    });
  }
}
